import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "كيف أعرف أن مشكلة المكيف تحتاج فحص كهربائي؟",
    a: "إذا توقف المكيف فجأة، أو ضعف التبريد بشكل مفاجئ، أو سمعت أصواتًا غير طبيعية عند التشغيل، فغالبًا الخلل كهربائي ويستدعي فحصًا دقيقًا قبل أي إصلاح ميكانيكي.",
  },
  {
    q: "متى يحتاج المكيف تعبئة فريون؟",
    a: "عند ضعف التبريد رغم عمل المكيف بكامل قوّته، أو وجود فرق خفيف في درجة حرارة مخارج الهواء. نفحص ضغط الفريون قبل أي تعبئة للتأكد من عدم وجود تسريب في الدورة.",
  },
  {
    q: "هل تقدمون خدمة فحص لجميع أنواع السيارات؟",
    a: "نعم، نخدم جميع أنواع السيارات — اليابانية، الأمريكية، الأوروبية، والكورية — سواء كانت قديمة أو حديثة، ونمتلك الخبرة العملية على معظم الموديلات.",
  },
  {
    q: "ما أسباب ضعف تبريد المكيف؟",
    a: "الأسباب متعددة: نقص الفريون، تسريب في الدورة، ضعف الكمبروسر، خلل في الثلاجة، اتساخ الفلاتر، أو مشكلة كهربائية. التشخيص الدقيق هو ما يحدد العلاج الصحيح.",
  },
  {
    q: "هل يتم تحديد العطل قبل الإصلاح؟",
    a: "نعم، هذا أساس عملنا. لا نقوم بأي إجراء قبل توضيح السبب الحقيقي للعميل، وذكر القطع المطلوبة والتكلفة المتوقعة.",
  },
  {
    q: "هل تتوفر صيانة لمكيفات السيارات القديمة والجديدة؟",
    a: "نعم، لدينا خبرة عملية واسعة في صيانة مكيفات السيارات بجميع موديلاتها، القديمة منها والحديثة، ونتعامل مع كل حالة حسب طبيعتها.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 lg:py-28 bg-slate-950"
    >
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center mb-12 reveal">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-cyan-400 font-semibold mb-4">
            <span className="w-8 h-px bg-cyan-400" />
            الأسئلة الشائعة
            <span className="w-8 h-px bg-cyan-400" />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
            إجابات واضحة لأهم الاستفسارات
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="reveal rounded-2xl border border-slate-800 bg-slate-900/60 divide-y divide-slate-800 overflow-hidden"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`q-${i}`}
              className="border-0 px-5 lg:px-6"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-right text-base lg:text-lg font-semibold text-white hover:text-cyan-300 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-slate-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
